module.exports = __webpack_public_path__ + "img/bilibili.89fdbf9b.png";